import React, { useEffect } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  authLogoutUser,
  SetCampusVirtualLogout,
  SetControlEscolarLogout,
  SetCajaLogout,
} from "../../store/actions"

//redux
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

const Logout = () => {
  const history = useNavigate()
  const dispatch = useDispatch()

  console.log("Corriendo el componente Logout")

  useEffect(() => {
    dispatch(authLogoutUser(history))
  }, [dispatch, history])

  useEffect(() => {
    console.log(
      "useEffect::Logout::SetCampusVirtualLogout::[dispatch, history]"
    )
    dispatch(SetCampusVirtualLogout(history))
  }, [dispatch, history])

  useEffect(() => {
    console.log(
      "useEffect::Logout::SetControlEscolarLogout::[dispatch, history]"
    )
    dispatch(SetControlEscolarLogout(history))
  }, [dispatch, history])

  useEffect(() => {
    console.log("useEffect::Logout::SetCajaLogout::[dispatch, history]")
    dispatch(SetCajaLogout(history))
  }, [dispatch, history])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
